export default {"src":"/_next/static/media/player-bg.56801f0c.svg","height":269,"width":495,"blurWidth":0,"blurHeight":0};